import { render } from "./TraderPayoutPlanForm.vue?vue&type=template&id=4d8409c8&ts=true"
import script from "./TraderPayoutPlanForm.vue?vue&type=script&lang=ts"
export * from "./TraderPayoutPlanForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__